/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Error_Code_Not_Logged_InInputs */

const en_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error Code: ${i?.status}. Log in an account to complete the purchase. Please contact support in the app if you need further help.`)
};

const ar_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`كود الخطأ: ${i?.status}. قم بتسجيل الدخول إلى حساب لإتمام الشراء. يرجى الاتصال بالدعم في التطبيق إذا كنت بحاجة إلى مزيد من المساعدة.`)
};

const de_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehlercode: ${i?.status}. Melden Sie sich in einem Konto an, um den Kauf abzuschließen. Bitte kontaktieren Sie den Support in der App, wenn Sie weitere Hilfe benötigen.`)
};

const es_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código de error: ${i?.status}. Inicia sesión en una cuenta para completar la compra. Ponte en contacto con el servicio de asistencia de la app si necesitas más ayuda.`)
};

const fr_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code d'erreur: ${i?.status}. Connectez-vous à l'application avec votre compte Forest pour finaliser l'achat. Contactez le support depuis l'application si vous avez besoin d'aide supplémentaire.`)
};

const it_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Codice Errore: ${i?.status}. Accedi a un account per completare l'acquisto. Ti preghiamo di contattare il supporto nell'app se hai bisogno di ulteriore aiuto.`)
};

const ja_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エラーコード：${i?.status}。アカウントにログインして購入してください。ご不明な点がございましたら、アプリ内のサポートまでお問い合わせください。`)
};

const ko_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`오류 코드: ${i?.status}. 구매를 완료하려면 계정에 로그인하세요. 추가 도움이 필요하면 앱에서 고객센터에 문의하세요.`)
};

const pt_br_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Código de erro: ${i?.status}. Inicie sessão em uma conta para concluir a compra. Entre em contato com o suporte no aplicativo se precisar de ajuda.`)
};

const ru_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Код ошибки: ${i?.status}. Войдите в аккаунт, чтобы завершить покупку. Свяжитесь с поддержкой в приложении, если вам нужна дополнительная помощь.`)
};

const th_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`รหัสข้อผิดพลาด: ${i?.status} เข้าสู่ระบบบัญชีเพื่อทำการซื้อให้เสร็จสมบูรณ์ โปรดติดต่อฝ่ายสนับสนุนในแอปหากคุณต้องการความช่วยเหลือเพิ่มเติม`)
};

const tr_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hata Kodu ${i?.status}. Satın alma işlemini tamamlamak için hesabına giriş yap. Daha fazla yardıma ihtiyacın olursa lütfen uygulamada destek hattıyla iletişime geç.`)
};

const zh_cn_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`错误代码：${i?.status}，尚未登录账号，无法购买。如有其他问题，请在 App 内联系客服。`)
};

const zh_tw_error_code_not_logged_in = /** @type {(inputs: Error_Code_Not_Logged_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`錯誤代碼：${i?.status}，目前尚未登入，無法購買。若有更多問題，請回到 App 聯繫客服。`)
};

/**
* | output |
* | --- |
* | "Error Code: {status}. Log in an account to complete the purchase. Please contact support in the app if you need further help." |
*
* @param {Error_Code_Not_Logged_InInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const error_code_not_logged_in = /** @type {((inputs: Error_Code_Not_Logged_InInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Code_Not_Logged_InInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_code_not_logged_in(inputs)
	if (locale === "ar") return ar_error_code_not_logged_in(inputs)
	if (locale === "de") return de_error_code_not_logged_in(inputs)
	if (locale === "es") return es_error_code_not_logged_in(inputs)
	if (locale === "fr") return fr_error_code_not_logged_in(inputs)
	if (locale === "it") return it_error_code_not_logged_in(inputs)
	if (locale === "ja") return ja_error_code_not_logged_in(inputs)
	if (locale === "ko") return ko_error_code_not_logged_in(inputs)
	if (locale === "pt_br") return pt_br_error_code_not_logged_in(inputs)
	if (locale === "ru") return ru_error_code_not_logged_in(inputs)
	if (locale === "th") return th_error_code_not_logged_in(inputs)
	if (locale === "tr") return tr_error_code_not_logged_in(inputs)
	if (locale === "zh_cn") return zh_cn_error_code_not_logged_in(inputs)
	return zh_tw_error_code_not_logged_in(inputs)
});